export default __webpack_public_path__ + "static/media/channel-sms-email.796b8d06.svg";